import React from 'react';
import './logout.css';

const LogoutLink = ({ onLogout }) => (
  <div className="logout-link-container">
    <a
      href="#logout"
      onClick={e => {
        e.preventDefault();
        onLogout();
      }}
      className="logout-link"
    >
      Logout
    </a>
  </div>
);

export default LogoutLink;